module.exports = __webpack_public_path__ + "img/9.35296608.png";